import { serviceRequest } from 'utils/http';
import { SiteEmployeeService } from 'common/api';

type FinishRegistrationAPIBody = {
  token: string;
  email: string;
  password: string;
};

export function finishRegistrationAPI(requestBody: FinishRegistrationAPIBody) {
  return serviceRequest(() =>
    SiteEmployeeService.siteEmployeeControllerFinishRegistration(requestBody)
  );
}
